var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4499 13.6401V14.6401C21.4499 14.9101 21.2399 15.1301 20.9599 15.1401H19.4999C18.9699 15.1401 18.4899 14.7501 18.4499 14.2301C18.4199 13.9201 18.5399 13.6301 18.7399 13.4301C18.9199 13.2401 19.1699 13.1401 19.4399 13.1401H20.9499C21.2399 13.1501 21.4499 13.3701 21.4499 13.6401Z",
    fill: "#677481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 12.6901C17.4902 13.1801 17.2502 13.9101 17.4502 14.6701C17.7102 15.6001 18.6202 16.1901 19.5802 16.1901H20.4502C21.0002 16.1901 21.4502 16.6401 21.4502 17.1901V17.3801C21.4502 19.4501 19.7602 21.1401 17.6902 21.1401H6.2102C4.1402 21.1401 2.4502 19.4501 2.4502 17.3801V10.6501C2.4502 9.42014 3.0402 8.33014 3.9502 7.65014C4.5802 7.17014 5.3602 6.89014 6.2102 6.89014H17.6902C19.7602 6.89014 21.4502 8.58014 21.4502 10.6501V11.0901C21.4502 11.6401 21.0002 12.0901 20.4502 12.0901H19.4302C18.8702 12.0901 18.3602 12.3101 17.9902 12.6901Z",
    fill: "#677481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 4.82C16.4701 5.09 16.2401 5.51 15.8601 5.51L8.18006 5.5C7.74006 5.5 7.51006 4.96 7.83006 4.65L9.45006 3.02C10.8201 1.66 13.0401 1.66 14.4101 3.02L16.1601 4.79C16.1701 4.8 16.1901 4.81 16.2001 4.82Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/Balance.b0ad7ecd110ff2ca967904fbb9b7c40d.svg";
export { ForwardRef as ReactComponent };